import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';

import AppLayout from '../../../layouts/AppLayout/AppLayout';
import { useLanguage } from '../../../context/LanguageProvider/LanguageProvider';
import { NioSection, NioIcon } from '../../../components';

function AboutSection({ title, children, className = '' }) {
  return (
    <section className={`jassp-about-section ${className}`.trim()}>
      <h2 className="jassp-about-section-title h3 mb-3">{title}</h2>
      {children}
    </section>
  );
}

function QuiSommesNous() {
  const { t } = useLanguage();

  const expertiseItems = [
    t('quiSommesNous.expertise.item1'),
    t('quiSommesNous.expertise.item2'),
    t('quiSommesNous.expertise.item3'),
    t('quiSommesNous.expertise.item4'),
    t('quiSommesNous.expertise.item5'),
  ];

  const valuesItems = [
    t('quiSommesNous.values.item1'),
    t('quiSommesNous.values.item2'),
    t('quiSommesNous.values.item3'),
    t('quiSommesNous.values.item4'),
    t('quiSommesNous.values.item5'),
  ];

  const statsItems = [
    t('quiSommesNous.stats.item1'),
    t('quiSommesNous.stats.item2'),
    t('quiSommesNous.stats.item3'),
    t('quiSommesNous.stats.item4'),
  ];

  return (
    <AppLayout variant={2} titleKey="pages.quiSommesNous.title" rootClass="layout-1">
      <div className="jassp-about-page">
        <section className="jassp-content-hero pt-7 pt-lg-120 pb-6 pb-lg-7">
          <Container>
            <Row className="justify-content-center text-center">
              <Col lg={10} xl={9}>
                <p className="jassp-about-hero-brand text-uppercase fw-semibold mb-3 mb-lg-4">
                  {t('quiSommesNous.hero.brand')}
                </p>
                <h1 className="jassp-content-hero-title display-5 fw-bold mb-4">
                  {t('quiSommesNous.hero.tagline')}
                </h1>
                <p className="jassp-content-hero-lead fs-18 mb-0 mx-auto">
                  {t('quiSommesNous.hero.intro')}
                </p>
              </Col>
            </Row>
          </Container>
        </section>

        <NioSection className="jassp-hero-light-gap pb-7 pb-lg-120 pt-4 pt-lg-5 bg-light">
          <Container>
            <Row className="justify-content-center">
              <Col lg={10} xl={9}>
                <p className="fs-18 text-gray-700 mb-5 pb-4 border-bottom">
                  {t('quiSommesNous.summary')}
                </p>

                <AboutSection title={t('quiSommesNous.history.h2')}>
                  <p className="fs-16 text-gray-700 mb-0">{t('quiSommesNous.history.body')}</p>
                </AboutSection>

                <AboutSection title={t('quiSommesNous.expertise.h2')} className="mt-5 pt-2">
                  <p className="fs-16 text-gray-700">{t('quiSommesNous.expertise.lead')}</p>
                  <p className="fw-semibold text-dark mb-2">{t('quiSommesNous.expertise.domainsLabel')}</p>
                  <ul className="jassp-about-list fs-16 text-gray-700 mb-0">
                    {expertiseItems.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                </AboutSection>

                <AboutSection title={t('quiSommesNous.values.h2')} className="mt-5 pt-2">
                  <ul className="jassp-about-list fs-16 text-gray-700 mb-0">
                    {valuesItems.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                </AboutSection>

                <AboutSection title={t('quiSommesNous.stats.h2')} className="mt-5 pt-2">
                  <ul className="jassp-about-list jassp-about-list--stats fs-16 text-gray-700 mb-0">
                    {statsItems.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                </AboutSection>

                <AboutSection title={t('quiSommesNous.mission.h2')} className="mt-5 pt-2">
                  <p className="fs-16 text-gray-700 mb-0">{t('quiSommesNous.mission.body')}</p>
                </AboutSection>

                <div className="text-center pt-5 mt-5 border-top">
                  <Link to="/" className="btn btn-outline-primary">
                    <NioIcon name="arrow-left" className="me-2" />
                    {t('portfolio.backHome')}
                  </Link>
                </div>
              </Col>
            </Row>
          </Container>
        </NioSection>
      </div>
    </AppLayout>
  );
}

export default QuiSommesNous;
